import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Thin wrapper so every call uses the same base URL. */
@Injectable({ providedIn: 'root' })
export class ApiService {
  private base = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get<T = any>(path: string, params?: { [k: string]: any }): Observable<T> {
    let p = new HttpParams();
    if (params) {
      Object.keys(params).forEach(k => {
        if (params[k] !== null && params[k] !== undefined && params[k] !== '') { p = p.set(k, String(params[k])); }
      });
    }
    return this.http.get<T>(this.base + path, { params: p });
  }
  post<T = any>(path: string, body: any = {}): Observable<T> { return this.http.post<T>(this.base + path, body); }
  put<T = any>(path: string, body: any = {}): Observable<T> { return this.http.put<T>(this.base + path, body); }
  delete<T = any>(path: string): Observable<T> { return this.http.delete<T>(this.base + path); }

  /** Pulls the readable message out of an API error. */
  static message(err: any, fallback = 'Something went wrong.'): string {
    if (!err) { return fallback; }
    if (err.status === 0) { return 'Cannot reach the server. Is the API running?'; }
    return (err.error && (err.error.message || err.error.Message)) || fallback;
  }
}
